import styled from 'styled-components'
import { devices } from '../../../../src/globalStyle'

export const Container = styled.div`
  display: flex;
  background-color: #fff;
  width: 84.3vw;
  height: 10vh;
  margin-top: 2.2vh;
  margin-left: 1vw;
  border-radius: 0.8vw;
  justify-content: space-between;
  align-items: center;

  @media ${devices.largeDesktop} {
    width: 87.7vw;
  }
`

export const TabsDiv = styled.div`
  display: flex;
  width: 22vw;
  height: 5.6vh;
  margin-left: 1vw;
  font-family: 'Inter', sans-serif;
  color: #696969;
  align-items: center;

  .active {
    border: 2px solid #0090d3;
    background-color: #e6f4fb;
    color: #0090d3;
  }
`

export const TableTabDiv = styled.div`
  display: flex;
  width: 11vw;
  border: 2px solid #ebebeb;
  border-top-left-radius: 1.4vw;
  border-bottom-left-radius: 1.4vw;
  align-items: center;
  height: 5.5vh;
  :hover {
    cursor: pointer;
  }

  @media ${devices.largeDesktop} {
    width: 7vw;
    height: 4vh;
  }
`

export const TableTabImg = styled.img`
  margin-left: 3vw;
  height: 1.4vh;

  @media ${devices.largeDesktop} {
    margin-left: 1.6vw;
  }
`

export const TableTabText = styled.h2`
  display: flex;
  margin-left: 0.6vw;
  margin-top: 1.12vw;
  margin-bottom: 1vw;
  font-size: 0.95vw;

  @media ${devices.largeDesktop} {
    font-size: 0.6vw;
    margin-left: 0.3vw;
  }
`

export const MovementTabDiv = styled.div`
  display: flex;
  width: 11vw;
  border: 2px solid #ebebeb;
  border-top-right-radius: 1.4vw;
  border-bottom-right-radius: 1.4vw;
  align-items: center;
  height: 5.5vh;

  :hover {
    cursor: pointer;
  }

  @media ${devices.largeDesktop} {
    width: 7vw;
    height: 4vh;
  }
`

export const MovementTabImg = styled.img`
  margin-left: 1.3vw;
  height: 1.4vh;

  @media ${devices.largeDesktop} {
    margin-left: 0.5vw;
  }
`

export const MovementTabText = styled.h2`
  display: flex;
  margin-left: 0.6vw;
  margin-top: 1.12vw;
  margin-bottom: 1vw;
  font-size: 0.95vw;

  @media ${devices.largeDesktop} {
    font-size: 0.6vw;
  }
`

export const TableOptionsDiv = styled.div`
  display: flex;
  position: relative;
  gap: 0.5rem;
  
  justify-content: space-between;
  align-items: center;
  margin-right: 1.5vw;
  font-family: 'Inter', sans-serif;

  /* @media ${devices.largeDesktop} {
    width: 10.5vw;
  } */
`

export const RefreshIcon = styled.img`
  margin-left: 1.3vw;
  height: 20px;
  cursor: pointer;

  @media ${devices.largeDesktop} {
    margin-left: 0.5vw;
  }
`

export const FilterDiv = styled.div`
  display: flex;
  width: 7vw;
  height: 5vh;
  border: 1.6px solid #0090d3;
  background-color: #fff;
  border-radius: 1.5vw;
  align-items: center;
  cursor: pointer;

  @media ${devices.largeDesktop} {
    width: 5vw;
    height: 4vh;
  }
`

export const FilterImg = styled.img`
  margin-left: 0.7vw;
  height: 4vh;
  @media ${devices.largeDesktop} {
    margin-left: 0.4vw;
    height: 3vh;
  }
`

export const FilterText = styled.h2`
  margin-left: 0.3vw;
  font-size: 0.95vw;
  color: #0090d3;

  @media ${devices.largeDesktop} {
    margin-left: 0.2vw;
    font-size: 0.75vw;
  }
`

export const MoreOptionsDiv = styled.div`
  display: flex;
  width: 2.8vw;
  height: 5vh;
  border: 1.6px solid #0090d3;
  border-radius: 1.5vw;
  background-color: #fff;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  @media ${devices.largeDesktop} {
    width: 3vw;
    height: 4vh;
  }
`

export const MoreOptionsText = styled.h2`
  font-size: 1vw;
  color: #0090d3;
  font-weight: bold;
  margin-top: 0.2vh;
  margin-bottom: 1vh;
`
export const FilterTypesDiv = styled.div`
  display: flex;
  gap: .8rem;
`

export const CompanyTypes = styled.div`
  font-size: .8rem;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 2px solid #B1B1B1;
  border-radius: .5rem;
  color: #B1B1B1;
  user-select: none;
  cursor: pointer;
  padding: .4rem .8rem;

  &.actived {
    color: #0090D3;
    border-color: #0090D3;
    font-weight: 600;
    background-color:#E6F4FB;
  }
`